import { render, staticRenderFns } from "./AirLanding.vue?vue&type=template&id=3493e1ea&"
import script from "./AirLanding.vue?vue&type=script&lang=js&"
export * from "./AirLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports